import { registerPlugin } from '@capacitor/core';

export interface StartupSyncPlugin {
  markReady(): Promise<void>;
}

const StartupSync = registerPlugin<StartupSyncPlugin>('StartupSync');

export default StartupSync;
